export default {
  // ========== 通用货币单位 ==========
  'currency.yuan': '元',

  // ========== 分账接收方 ==========
  'button.profitReceiver.create': '创建分账接收方',
  'error.profitReceiver.loadListFailed': '加载分账接收方列表失败',
  'error.profitReceiver.deleteFailed': '删除分账接收方失败',
  'error.profitReceiver.operationFailed': '分账接收方操作失败',
  'table.profitReceiver.name': '接收方名称',
  'table.profitReceiver.ownerType': '所有者类型',
  'table.profitReceiver.ownerName': '所有者',
  'table.profitReceiver.phone': '联系手机',
  'table.profitReceiver.wxReceiverAccount': '微信商户号',
  'table.profitReceiver.aliReceiverAccount': '支付宝账号',
  'table.profitReceiver.wxBound': '微信绑定状态',
  'table.profitReceiver.aliBound': '支付宝绑定状态',
  'status.bound.bound': '已绑定',
  'status.bound.notBound': '未绑定',
  'status.bound.notConfigured': '未配置',
  'modal.profitReceiver.deleteTitle': '删除分账接收方',
  'modal.profitReceiver.deleteContent': '确定要删除该分账接收方吗？',
  'modal.profitReceiver.updateTitle': '修改分账接收方',
  'modal.profitReceiver.createTitle': '创建分账接收方',
  'form.profitReceiver.brandId': '所属品牌',
  'form.profitReceiver.ownerType': '所有者类型',
  'form.profitReceiver.ownerId': '所属门店',
  'form.profitReceiver.name': '接收方名称',
  'form.profitReceiver.phone': '联系手机',
  'form.profitReceiver.password': '初始密码',
  'form.profitReceiver.phoneTooltip': '用于资金账户登录',
  'form.profitReceiver.wxReceiverAccount': '微信接收方商户号',
  'form.profitReceiver.wxReceiverName': '微信接收方名称',
  'form.profitReceiver.wxRelationType': '微信分账关系类型',
  'form.profitReceiver.aliReceiverAccount': '支付宝接收方登录名',
  'form.profitReceiver.aliReceiverName': '支付宝接收方名称',
  'form.profitReceiver.wxBoundStatus': '微信绑定状态',
  'form.profitReceiver.aliBoundStatus': '支付宝绑定状态',
  'form.profitReceiver.autoBindingTip': '提示：填写微信/支付宝接收方信息后，系统会自动调用平台接口绑定分账关系。绑定失败不会影响保存，可在列表中查看绑定状态。',
  'validation.profitReceiver.brandIdRequired': '请选择品牌',
  'validation.profitReceiver.ownerIdRequired': '请选择门店',
  'validation.profitReceiver.nameRequired': '请输入接收方名称',
  'validation.profitReceiver.phoneRequired': '请输入联系手机号',
  'modal.profitReceiver.accountCreated': '资金账户创建成功',
  'modal.profitReceiver.accountInfo': '系统已为该接收方创建资金账户，可使用以下信息登录查看分账记录：',
  'modal.profitReceiver.passwordTip': '⚠️ 请妥善保管初始密码，登录后可修改密码',

  // ========== 品牌分账预设 ==========
  'button.brandProfitPreset.create': '创建品牌分账预设',
  'error.brandProfitPreset.loadListFailed': '加载品牌分账预设列表失败',
  'error.brandProfitPreset.deleteFailed': '删除品牌分账预设失败',
  'error.brandProfitPreset.operationFailed': '品牌分账预设操作失败',
  'table.brandProfitPreset.receiverName': '接收方',
  'table.brandProfitPreset.sharingType': '分账类型',
  'table.brandProfitPreset.fixedAmount': '固定金额',
  'table.brandProfitPreset.ratio': '分账比例',
  'modal.brandProfitPreset.deleteTitle': '删除品牌分账预设',
  'modal.brandProfitPreset.deleteContent': '确定要删除该品牌分账预设吗？',
  'modal.brandProfitPreset.updateTitle': '修改品牌分账预设',
  'modal.brandProfitPreset.createTitle': '创建品牌分账预设',
  'form.brandProfitPreset.brandId': '所属品牌',
  'form.brandProfitPreset.receiverId': '分账接收方',
  'form.brandProfitPreset.sharingType': '分账类型',
  'form.brandProfitPreset.fixedAmount': '固定金额',
  'form.brandProfitPreset.fixedAmountTooltip': '每笔订单固定分账的金额（单位：元）',
  'form.brandProfitPreset.ratio': '分账比例',
  'form.brandProfitPreset.ratioTooltip': '按订单金额百分比分账，例如：10 表示 10%',
  'validation.brandProfitPreset.brandIdRequired': '请选择品牌',
  'validation.brandProfitPreset.receiverIdRequired': '请选择分账接收方',
  'validation.brandProfitPreset.fixedAmountRequired': '请输入固定金额',
  'validation.brandProfitPreset.ratioRequired': '请输入分账比例',

  // ========== 门店分账规则 ==========
  'button.storeProfitRule.create': '创建门店分账规则',
  'error.storeProfitRule.loadListFailed': '加载门店分账规则列表失败',
  'error.storeProfitRule.deleteFailed': '删除门店分账规则失败',
  'error.storeProfitRule.operationFailed': '门店分账规则操作失败',
  'table.storeProfitRule.ownerType': '所有者类型',
  'table.storeProfitRule.receiverName': '接收方',
  'table.storeProfitRule.sharingType': '分账类型',
  'table.storeProfitRule.fixedAmount': '固定金额',
  'table.storeProfitRule.ratio': '分账比例',
  'modal.storeProfitRule.deleteTitle': '删除门店分账规则',
  'modal.storeProfitRule.deleteContent': '确定要删除该门店分账规则吗？',
  'modal.storeProfitRule.updateTitle': '修改门店分账规则',
  'modal.storeProfitRule.createTitle': '创建门店分账规则',
  'form.storeProfitRule.brandId': '所属品牌',
  'form.storeProfitRule.storeId': '所属门店',
  'form.storeProfitRule.ownerType': '所有者类型',
  'form.storeProfitRule.receiverId': '分账接收方',
  'form.storeProfitRule.sharingType': '分账类型',
  'form.storeProfitRule.fixedAmount': '固定金额',
  'form.storeProfitRule.fixedAmountTooltip': '每笔订单固定分账的金额（单位：元）',
  'form.storeProfitRule.ratio': '分账比例',
  'form.storeProfitRule.ratioTooltip': '按订单金额百分比分账，例如：10 表示 10%',
  'validation.storeProfitRule.brandIdRequired': '请选择品牌',
  'validation.storeProfitRule.storeIdRequired': '请选择门店',
  'validation.storeProfitRule.receiverIdRequired': '请选择分账接收方',
  'validation.storeProfitRule.fixedAmountRequired': '请输入固定金额',
  'validation.storeProfitRule.ratioRequired': '请输入分账比例',

  // ========== 分账记录 ==========
  'button.common.view': '查看',
  'button.profitSharing.retry': '重新分账',
  'error.profitSharing.loadListFailed': '加载分账记录列表失败',
  'error.profitSharing.loadDetailFailed': '加载分账记录详情失败',
  'message.profitSharing.retrySuccess': '重新分账成功',
  'message.profitSharing.retryConfirm': '确定要重新分账吗？',
  'table.profitSharing.sharingNo': '分账单号',
  'table.profitSharing.orderNo': '订单号',
  'table.profitSharing.payChannel': '支付渠道',
  'table.profitSharing.transactionId': '第三方交易号',
  'table.profitSharing.totalAmount': '订单金额',
  'table.profitSharing.totalSharingAmount': '总分账金额',
  'table.profitSharing.receiverCount': '接收方数量',
  'table.profitSharing.sharingStatus': '分账状态',
  'table.profitSharing.sharingTime': '分账完成时间',
  'table.profitSharing.failureReason': '失败原因',
  'table.profitSharing.receiverName': '接收方',
  'table.profitSharing.receiverAccount': '接收方账号',
  'table.profitSharing.sharingType': '分账类型',
  'table.profitSharing.sharingRatio': '分账比例',
  'table.profitSharing.sharingRule': '分账规则',
  'table.profitSharing.sharingAmount': '实际分账金额',
  'table.profitSharing.detailStatus': '明细状态',
  'modal.profitSharing.detailTitle': '分账记录详情',
  'modal.profitSharing.detailsTitle': '分账明细',

  // ========== 枚举值 ==========
  // 所有者类型
  'enum.ownerType.brand': '品牌级',
  'enum.ownerType.store': '门店级',
  // 分账类型
  'enum.sharingType.fixed': '固定金额',
  'enum.sharingType.ratio': '按比例',
  'enum.sharingType.mixed': '混合模式',
  // 微信分账关系类型
  'enum.wxRelationType.supplier': '供应商',
  'enum.wxRelationType.distributor': '分销商',
  'enum.wxRelationType.serviceProvider': '服务商',
  'enum.wxRelationType.platform': '平台',
  'enum.wxRelationType.others': '其他',
  // 支付渠道
  'enum.payChannel.wechat': '微信支付',
  'enum.payChannel.alipay': '支付宝',
  // 分账状态
  'enum.sharingStatus.pending': '待分账',
  'enum.sharingStatus.processing': '分账中',
  'enum.sharingStatus.success': '成功',
  'enum.sharingStatus.partialSuccess': '部分成功',
  'enum.sharingStatus.failed': '失败',

  // ========== 退分账记录 ==========
  'button.refund.viewProfitSharingReturns': '查看退分账记录',
  'error.profitSharingReturn.loadListFailed': '加载退分账记录列表失败',
  'error.profitSharingReturn.loadDetailFailed': '加载退分账记录详情失败',
  'table.profitSharingReturn.returnNo': '退分账单号',
  'table.profitSharingReturn.refundNo': '退款单号',
  'table.profitSharingReturn.sharingNo': '分账单号',
  'table.profitSharingReturn.orderNo': '订单号',
  'table.profitSharingReturn.payChannel': '支付渠道',
  'table.profitSharingReturn.totalReturnAmount': '总回退金额',
  'table.profitSharingReturn.receiverCount': '接收方数量',
  'table.profitSharingReturn.returnStatus': '回退状态',
  'table.profitSharingReturn.returnTime': '回退时间',
  'table.profitSharingReturn.failureReason': '失败原因',
  'table.profitSharingReturn.receiverName': '接收方',
  'table.profitSharingReturn.receiverAccount': '接收方账号',
  'table.profitSharingReturn.originalSharingAmount': '原分账金额',
  'table.profitSharingReturn.returnAmount': '回退金额',
  'table.profitSharingReturn.thirdPartyReturnNo': '第三方回退单号',
  'table.profitSharingReturn.detailStatus': '明细状态',
  'modal.profitSharingReturn.detailTitle': '退分账记录详情',
  'modal.profitSharingReturn.detailsTitle': '回退明细',
  // 回退状态
  'enum.returnStatus.pending': '待回退',
  'enum.returnStatus.processing': '回退中',
  'enum.returnStatus.success': '回退成功',
  'enum.returnStatus.partialSuccess': '部分成功',
  'enum.returnStatus.failed': '回退失败',

  // ========== 资金账户 ==========
  'error.fundAccount.loadListFailed': '加载分账记录失败',
  'error.fundAccount.loadProfileFailed': '加载账户信息失败',
  'error.fundAccount.loadStatisticsFailed': '加载统计数据失败',
  'table.fundAccount.statistics': '统计数据',
  'table.fundAccount.totalAmount': '累计分账金额',
  'table.fundAccount.totalCount': '累计分账笔数',
  'table.fundAccount.monthAmount': '本月分账金额',
  'table.fundAccount.monthCount': '本月分账笔数',
  'table.fundAccount.profile': '账户信息',
  'table.fundAccount.phone': '手机号',
  'table.fundAccount.brandName': '所属品牌',
  'table.fundAccount.receivers': '关联接收方',
  'table.fundAccount.receiverName': '接收方名称',
  'table.fundAccount.receiverStatus': '状态',
  'modal.fundAccount.detailTitle': '分账详情',
  'modal.fundAccount.detailsTitle': '分账明细',
  'enum.receiverStatus.disabled': '已禁用',
  'enum.receiverStatus.enabled': '已启用',
};
